<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class="" cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px; padding-top: 40px; padding-bottom: 100px"
        class="term_service"
      >
        <h1 style='text-align:center'>Return & Refund Policy</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <p>
          Truthbrush.com can only refund orders placed directly through our website. If you purchased your Truthbrush products through another merchant or in another country, please contact your seller for return instructions. 
Truthbrush (Candibell, Inc) offers a 30 day return policy that allows you to return or exchange your fully functional and undamaged Truthbrush device for any reason within 30 days of purchase of your original order. Shipping and handling charges from your original order are non-refundable.  Shipping charges for returns are not covered by Truthbrush (Candibell, Inc).  We allow only one return or exchange per original order. Partial returns, returns without packaging, or with damaged products are not eligible for refund.
        </p>
        <p>
          <b>Please return your order with information of your order ID or receipt to:</b>
          <br />
          Return Shipment<br />
          Candibell Inc.<br />
          600 Suffolk St Suite 250, <br />
          Lowell, MA 01854<br />
        </p>

        <p>
          Before sending, please be sure to:
          <ul>
            <li>Turn off the device to avoid battery depletion during transportation (see instructions in user manual). In the case of the Truthbrush Pro Tracker, please remove the battery completely from the tracker.
</li>
<li>Delete the tracker and/or hubs from your Truthbrush account / Truthbrush app (This is important to enable a technical quality assessment). Returned products that are still linked to the user account are subject to a 25% restocking fee. 
</li>
          </ul>
        </p>
        <p>
          If you experience any issues at all during this process, please do not hesitate to reach out to us.

        </p>

      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
  },
};
</script>

<style lang="scss">
.term_service h2 {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .term_service h2,
  .term_service h4 {
    text-align: center;
  }
}
</style>